/**
* UTM PARAM GRABBER
* Persistently keep UTM params in URL even after navigating to new page 
*/

// jQuery wrapper function 
(function($) {

  // UTM params 
  $(document).ready(function() {

    // let newParams = new URLSearchParams(document.location.search);
    // const paramArray = ['utm, campaignid, adgroupid, gclid, REFERRALCOD, RR_WCID, RR_WCID_TTLW'];
    // const hasParams = paramArray.reduce(
    //   (accumulator, currentValue) => accumulator || currentValue,
    //   false
    //   );
    // console.log(hasParams);

    var cr_req = window.location.href;
    var temp_params_string = '';
    var temp_params_parts = '';
    var temp_href = '';

    // If URL contains '?' and NOT '?s', get relevant UTM params and attach 
    // them to all links on page except those with the class .utmIgnoreLink 
    // The '?s' param is used by WordPress for search, so this is a compromise 
    // to get the search and UTM params to coexist without breaking one another 
    if( cr_req.search(/\?/) > -1 && cr_req.search(/\?s/) < 0 && ( // include '?' and exclude '?s'
        cr_req.search('utm') > -1 || 
        cr_req.search('utm_campaign') || 
        cr_req.search('utm_medium') || 
        cr_req.search('utm_source') || 
        cr_req.search('utm_term') || 
        cr_req.search('utm_content') || 
        cr_req.search('last%20source') || 
        cr_req.search('campaignid') || 
        cr_req.search('adgroupid') || 
        cr_req.search('person%20source') || 
        cr_req.search('gclid') || 
        cr_req.search('msclkid') || 
        cr_req.search('channelpartner') ) ) {

      var params = cr_req.split('?')[1];

      $("a:not('.utmIgnoreLink')").each(function() {
        if( $(this).attr('href') != '#' && $(this).attr('href') != null ) { 

          if( $(this).attr('href').search(/\?/) < 0 ) { // if URL doesn't have '?' params, add them 
            $(this).attr('href', $(this).attr('href') + '?' + params );
          } 

        }
        // alert($(this).attr('href'));
        // console.log('window param found');
      });
    }

  });

})(jQuery);










// Log to indicate the script is about to load
console.log('Pantheon script about to load...');

// Map field IDs to UTM parameters
const fieldIdToUtmParam = {
  'nf-field-92': 'utm_campaign',
  'nf-field-93': 'utm_medium',
  'nf-field-94': 'utm_source',
  'nf-field-95': 'utm_term',
  'nf-field-96': 'utm_content'
};

// Function to be called when the Ninja Form is detected
const pantheonUnstripped = () => {
  console.log('PantheonUnstripped function is running after detecting Ninja Form...');

  // Retrieve UTM params from localStorage
  const getUtmFromLocalStorage = () => {
    console.log('Retrieving UTM params from localStorage...');
    const utmParams = {};
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('utm_')) {
        utmParams[key] = localStorage.getItem(key);
        console.log(`Found ${key} in localStorage: ${utmParams[key]}`);
      }
    });
    console.log('All retrieved UTM parameters:', utmParams);
    return utmParams;
  };

  // Recursive function to search for hidden fields
  const findHiddenFieldsRecursively = (element, foundFields = []) => {
    if (element.nodeName === 'INPUT' && element.type === 'hidden') {
      foundFields.push(element);
    }

    Array.from(element.children).forEach((child) => {
      findHiddenFieldsRecursively(child, foundFields);
    });

    return foundFields;
  };

  // Populate form fields with UTM params from localStorage
  const populateFieldsWithUtm = (utmParams) => {
    // Collect all forms on the page that are inside .ninjaForm
    const ninjaForms = document.querySelectorAll('.ninjaForm form');
    console.log(`Ninja Forms found on page: ${ninjaForms.length}`);

    let updatedFields = [];

    // For each Ninja Form, find hidden fields and update the values
    ninjaForms.forEach((form, formIndex) => {
      console.log(`Processing Ninja Form ${formIndex + 1} of ${ninjaForms.length}`);

      // Use recursive function to find all hidden fields
      const hiddenFields = findHiddenFieldsRecursively(form);
      console.log(`Hidden fields found in Ninja Form ${formIndex + 1}: ${hiddenFields.length}`);

      hiddenFields.forEach((hidden, fieldIndex) => {
        console.log(`Processing hidden field ${fieldIndex + 1} of ${hiddenFields.length}:`, hidden);

        const fieldId = hidden.id || hidden.name;
        console.log(`Field ID or Name: ${fieldId}`);

        // Check if this field is one of the UTM-related hidden fields
        if (fieldIdToUtmParam[fieldId]) {
          const utmParam = fieldIdToUtmParam[fieldId];
          console.log(`Mapped ${fieldId} to UTM parameter ${utmParam}`);

          if (hidden.value === "PANTHEON_STRIPPED" && utmParams[utmParam]) {
            console.log(`Replacing "PANTHEON_STRIPPED" with ${utmParams[utmParam]} for ${fieldId}`);
            hidden.value = utmParams[utmParam];
            updatedFields.push(`${fieldId}: ${utmParams[utmParam]}`);
          }
        }
      });
    });

    if (updatedFields.length > 0) {
      console.warn('The following Ninja Form fields have been updated: ', { updatedFields });
    } else {
      console.warn('No Ninja Form fields were updated.');
    }
  };

  // Retrieve UTM parameters from localStorage
  const storedUtmParams = getUtmFromLocalStorage();

  // Populate form fields with UTM parameters from localStorage
  populateFieldsWithUtm(storedUtmParams);
};

// Use MutationObserver to detect when Ninja Forms are added to the DOM
const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      const ninjaForm = document.querySelector('.ninjaForm form');
      if (ninjaForm) {
        console.log('Ninja Form detected. Running pantheonUnstripped...');

        // Wait for 2 seconds after the form is detected to ensure fields are fully rendered
        setTimeout(() => {
          observer.disconnect(); // Stop observing once the Ninja Form is detected
          pantheonUnstripped();
        }, 2000);
      }
    }
  }
});

// Start observing the document body for changes (e.g., when Ninja Forms are added)
observer.observe(document.body, { childList: true, subtree: true });

